<ng-container *ngIf="dialog$ | async as dialog">
  <div class="modal-header justify-content-start">
    <div class="modal-title">Registration button</div>
  </div>
  <div class="modal-body" [formGroup]="button">
    <mdb-form-control class="form-fill" data-panel="settings">
      <mdb-select formControlName="registrationType" class="mdb-select" [(ngModel)]="registrationType" data-panel="settings">
        <mdb-option *ngFor="let type of registrationTypes" [value]="type.id" [disabled]="!!eventConfigData.inPersonEventInfo">
          <ng-container *ngIf="(type.id === 0 && eventConfigData.inPersonEventInfo) || eventConfigData.hybridEventInfo || eventConfigData.virtualEventInfo" >
           {{type.label}}
          </ng-container>
      </mdb-option>
      </mdb-select>
      <label mdbLabel class="form-label form-label--paybee">Select button type</label>
    </mdb-form-control>

    <ng-container *ngIf="ticketingCampaigns$ | async as ticketingCampaigns">
      <mdb-form-control class="form-fill" *ngIf="registrationType === 0" data-panel="settings">
        <mdb-select formControlName="campaignId" class="mdb-select" [(ngModel)]="selectedCampaign" data-panel="settings" [filter]="true">
          <mdb-option *ngFor="let campaign of ticketingCampaigns" [value]="campaign.id">{{
            campaign.name
          }}</mdb-option>
        </mdb-select>
        <label mdbLabel class="form-label form-label--paybee">Select Campaign</label>
        <span class="form-fill-error" *ngIf="button.controls.campaignId.hasError('required') && button.controls.campaignId.touched">Please Provide Campaign</span>
      </mdb-form-control>
    </ng-container>
    <mdb-form-control class="form-fill">
      <app-mdbp-input mdbInput maxLength="16" formControlName="label" label='Button Label'></app-mdbp-input>
      <span class="form-fill-error"  *ngIf="button.controls.label.hasError('required') && button.controls.label.touched ">Please provide Label for a button</span>
    </mdb-form-control>
    <mdb-form-control class="form-fill textarea-control">
      <app-mdb-textarea mdbInput formControlName="desc"  maxLength="256" label="Description"></app-mdb-textarea>
    </mdb-form-control>

    <div class="divider"></div>
  </div>
  <div class="modal-footer modal-footer--add-guest">
    <div class="row">
      <div class="col-4 offset-4">
        <button type="button" class="btn btn--paybee btn--transparent btn--md text-center w-100" (click)="close(dialog, false)">Cancel</button>
      </div>
      <div class="col-4">
        <button type="button" class="btn btn--paybee btn--black btn--md text-center w-100" (click)="confirm(dialog, button.value)">Confirm</button>
      </div>
    </div>
  </div>
</ng-container>
